// The observed width of the FormFieldDate input component. If we make styling changes to this component that affect its
// width, we should update this value to reflect the new observed width.
// eslint-disable-next-line import/prefer-default-export
export const FORM_FIELD_DATE_WIDTH = 170;
